// One SVG icon set for the whole app (replaces the emoji the desktop port used). 24-unit grid, stroke only,
// coloured by `currentColor`, so an icon looks the same on every OS and in both themes.
import type { SVGProps } from "react";

const PATHS = {
  upload: "M12 16V4m0 0-4 4m4-4 4 4M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3",
  download: "M12 4v12m0 0-4-4m4 4 4-4M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3",
  folder: "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z",
  cube: "M12 3 4 7.5v9L12 21l8-4.5v-9L12 3Zm-8 4.5 8 4.5 8-4.5M12 12v9",
  tag: "M3 12V4h8l9 9-8 8-9-9Zm4.5-4.5h.01",
  check: "m5 12 5 5L20 7",
  trash: "M4 7h16M9 7V4h6v3m-7 0 1 13h6l1-13",
  sparkles: "M12 3v4m0 10v4m-9-9h4m10 0h4M6.5 6.5l2.5 2.5m6 6 2.5 2.5m0-11-2.5 2.5m-6 6-2.5 2.5",
  wand: "m4 20 10-10m2-6 1 2 2 1-2 1-1 2-1-2-2-1 2-1Zm-9 1 .5 1.5L9 7l-1.5.5L7 9l-.5-1.5L5 7l1.5-.5Z",
  target: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-4a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  play: "M7 5v14l12-7Z",
  stop: "M6 6h12v12H6Z",
  refresh: "M20 11a8 8 0 0 0-14.5-4.5L4 8m0-4v4h4m-4 1a8 8 0 0 0 14.5 4.5L20 16m0 4v-4h-4",
  hand: "M8 12V6a1.5 1.5 0 0 1 3 0v5m0-6V4a1.5 1.5 0 0 1 3 0v7m0-6a1.5 1.5 0 0 1 3 0v8m0-5a1.5 1.5 0 0 1 3 0v4a7 7 0 0 1-7 7h-1.5a6 6 0 0 1-4.8-2.4L4.5 15A1.6 1.6 0 0 1 7 13.2l1 1.3",
  box: "M4 6h16v12H4Z",
  polygon: "M12 3l9 6.5-3.5 10.5h-11L3 9.5Z",
  rotatedBox: "M7 4l13 7-7 9-9-7Z",
  zoomIn: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm9 2-4-4M11 8v6m-3-3h6",
  zoomOut: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm9 2-4-4M8 11h6",
  fit: "M4 9V4h5m6 0h5v5m0 6v5h-5m-6 0H4v-5",
  keyboard: "M3 7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm4 3h.01M11 10h.01M15 10h.01M7 14h10",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8a7 7 0 0 1 14 0",
  sun: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-15v2m0 16v2M4.2 4.2l1.4 1.4m12.8 12.8 1.4 1.4M2 12h2m16 0h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4",
  moon: "M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z",
  volume: "M4 10v4h4l5 4V6L8 10H4Zm12.5-.5a4 4 0 0 1 0 5m2.5-8a8 8 0 0 1 0 11",
  volumeOff: "M4 10v4h4l5 4V6L8 10H4Zm12 0 5 5m0-5-5 5",
  credit: "M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm0 3h18M7 15h4",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  eyeOff: "M3 3l18 18M10.6 5.2A10 10 0 0 1 12 5c6 0 10 7 10 7a17 17 0 0 1-3.2 3.9M6.6 6.6A17 17 0 0 0 2 12s4 7 10 7a10 10 0 0 0 3.4-.6M9.9 9.9a3 3 0 0 0 4.2 4.2",
  chevronLeft: "m15 5-7 7 7 7",
  chevronRight: "m9 5 7 7-7 7",
  arrowLeft: "M19 12H5m0 0 6-6m-6 6 6 6",
  ruler: "m3 17 14-14 4 4L7 21Zm5-9 2 2m1-5 2 2m1-5 2 2M5 15l2 2",
  camera3d: "M4 8V5a1 1 0 0 1 1-1h3m8 0h3a1 1 0 0 1 1 1v3m0 8v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3m8-9 5 3v6l-5 3-5-3V10Zm0 0v6m-5-3 5 3 5-3",
  import: "M12 3v10m0 0 4-4m-4 4-4-4M4 14v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5",
  layers: "m12 3 9 5-9 5-9-5Zm-9 9 9 5 9-5m-18 4 9 5 9-5",
  x: "M6 6l12 12M18 6 6 18",
  info: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-5v-5m0-3h.01",
  image: "M4 5h16v14H4Zm0 11 4.5-4.5 3 3 4-5L20 15M9 9.5h.01",
  more: "M5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
  chevronDown: "m6 9 6 6 6-6",
  shield: "M12 3 5 6v6c0 4.2 2.9 7.3 7 9 4.1-1.7 7-4.8 7-9V6Z",
  help: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-2.5-11.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.6m0 3h.01",
  undo: "M9 14 4 9l5-5M4 9h11a5 5 0 0 1 0 10h-3",
  redo: "m15 14 5-5-5-5m5 5H9a5 5 0 0 0 0 10h3",
  loader: "M12 3v3m0 12v3m9-9h-3M6 12H3m15.4-6.4-2.1 2.1M7.7 16.3l-2.1 2.1m12.8 0-2.1-2.1M7.7 7.7 5.6 5.6",
} as const;

export type IconName = keyof typeof PATHS;

/** `<Icon name="upload" />`: 16 px by default, inherits the text colour. Decorative unless given an aria-label. */
export function Icon({ name, size = 16, className, ...rest }: { name: IconName; size?: number } & Omit<SVGProps<SVGSVGElement>, "name">) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round"
      aria-hidden={rest["aria-label"] ? undefined : true} className={className ? `icon ${className}` : "icon"} {...rest}>
      <path d={PATHS[name]} />
    </svg>
  );
}
